import "@/App.css";
import { Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import "./i18n";
import LanguageSelector from "./components/LanguageSelector";
import VoiceflowChat from "./components/VoiceflowChat";
import Hero from "./components/Hero";
import Services from "./components/Services";
import Gallery from "./components/Gallery";
import Testimonials from "./components/Testimonials";
import LoyaltyProgram from "./components/LoyaltyProgram";
import Booking from "./components/Booking";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

const LoadingFallback = () => (
  <div className="min-h-screen bg-black flex items-center justify-center">
    <div className="text-white text-xl">Betöltés...</div>
  </div>
);

const Home = () => {
  return (
    <div className="bg-black">
      <LanguageSelector />
      <VoiceflowChat />
      <Hero />
      <Services />
      <Gallery />
      <Testimonials />
      <LoyaltyProgram />
      <Booking />
      <Contact />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster theme="dark" />
      <Suspense fallback={<LoadingFallback />}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
      </Suspense>
    </div>
  );
}

export default App;
